<template>
    <div>

        <menu-bar></menu-bar>

        <div class="container" role="main">

            <div class="row" style="margin-top: 50px" v-if="cliente">

                <ol class="breadcrumb">
                    <li><a href="#/"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a href="#/concentradores">CONCENTRADORES</a></li>
                    <li class="active">CADASTRO DE CONTRATOS</li>
                </ol>

                <div class="col-md-3">
                    <menu-concentrador :concentrador="cliente" ></menu-concentrador>
                </div>
                <div class="col-md-9" >

                    <status-ping v-if="cliente.ssh && cliente._id" :ip="cliente.ssh.host"></status-ping>

                    <form class="form-horizontal">

                        <div class="panel panel-info">
                            <!-- Default panel contents -->
                            <div class="panel-heading">
                                <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                            </div>
                            <div class="panel-body">
                                <div class="form-group">

                                    <div class="col-sm-6">
                                        <label :class="{'text-danger': !cliente.nome}" class="control-label">NOME DO CONCENTRADOR</label>
                                        <input :disabled="user.level >= 5" type="text" v-model="cliente.nome" class="form-control" >
                                    </div>

                                    <div class="col-sm-6">
                                        <label :class="{'text-danger': !cliente.interface}" class="control-label">INTERFACE</label>
                                        <input :disabled="user.level >= 5" type="text" v-model="cliente.interface" class="form-control" >
                                    </div>

                                </div>
                            </div>
                        </div>

                        <ssh v-if="user.level < 5" :ssh="cliente.ssh"></ssh>

                        <div class="form-group">
                            <div class="col-sm-10">
                                <button type="button" v-if="user.level < 5" :disable="! cliente.nome ||! cliente.interface"
                                        @click="save()"
                                        class="btn btn-success">
                                    <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR CONCENTRADOR
                                </button>
                            </div>
                        </div>

                    </form>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import MenuConcentrador from "../../../menus/concentrador.vue";
import { router } from "../../../router";
import { Concentrador } from "../../../class/concentrador";
import { Ssh, StatusPing } from "../../../components/exports";

/* global swal */

export default {
    components: {
        MenuConcentrador,
        Ssh,
        StatusPing
    },
    data() {
        return {
            cliente: null,
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
        if (this.$route.params.id) {
            this.load(this.$route.params.id);
        } else {
            this.cliente = Concentrador.create();
        }
    },
    methods: {
        load(id) {
            Concentrador.byID(id)
                .then(row => (this.cliente = row))
                .catch(err => {
                    console.log(err);
                });
        },
        save() {
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o cliente?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            Concentrador.save(this.cliente)
                                .then(() => {
                                    resolve();
                                    router.push({ path: "/concentradores" });
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
